import { useSearch } from '@tanstack/react-router';
import { PageHeader } from '@/shared/components';
import { CreateWizard } from './create-wizard/CreateWizard';

export function PropertyCreatePage() {
  // objectId aus der Objektdetailseite („Apartment hinzufügen") belegt Schritt 1 vor.
  const { objectId } = useSearch({ from: '/_admin/properties/new' });

  return (
    <>
      <PageHeader
        eyebrow="Neu"
        title="Apartment"
        titleAccent="anlegen"
        description="In drei Schritten: Standort, Apartment, Betrieb. Das Apartment entsteht als Entwurf — die Channex-Veröffentlichung folgt auf der Detailseite."
      />
      <CreateWizard preselectedObjectId={objectId} />
    </>
  );
}
